import Tab from "components/Tab";
import APISendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-api.mdx";
import WebSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-web.mdx";
import ReactSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-react.mdx";
import NodeSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-node.mdx";
import PythonSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-python.mdx";
import PHPSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-php.mdx";
import RubySendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-ruby.mdx";
import GoSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-go.mdx";
import ReactNativeSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-react-native.mdx";
import AndroidSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-android.mdx";
import IOSSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-ios.mdx";
import JavaSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-java.mdx";
import RustSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-rust.mdx";
import FlutterSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-flutter.mdx";
import ElixirSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-elixir.mdx";
import DotNetSendEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-dotnet.mdx";
import IdentifiedVsAnonymousIntro from "../../../../contents/docs/product-analytics/_snippets/identified-vs-anonymous-intro.mdx";
import HowToCaptureAnonymousEventsBackend from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-backend-and-api.mdx";
import HowToCaptureAnonymousEventsIOS from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-events-ios.mdx";
import HowToCaptureAnonymousEventsWeb from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-events-web.mdx";
import HowToCaptureAnonymousEventsAndroid from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-events-android.mdx";
import HowToCaptureAnonymousEventsFlutter from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-events-flutter.mdx";
import HowToCaptureIdentifiedEventsFrontend from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-frontend.mdx";
import HowToCaptureIdentifiedEventsBackend from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-backend.mdx";
import HowToCaptureIdentifiedEventsAndroid from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-android.mdx";
import HowToCaptureIdentifiedEventsiOS from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-ios.mdx";
import HowToCaptureIdentifiedEventsFlutter from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-flutter.mdx";
import * as React from 'react';
export default {
  Tab,
  APISendEvent,
  WebSendEvent,
  ReactSendEvent,
  NodeSendEvent,
  PythonSendEvent,
  PHPSendEvent,
  RubySendEvent,
  GoSendEvent,
  ReactNativeSendEvent,
  AndroidSendEvent,
  IOSSendEvent,
  JavaSendEvent,
  RustSendEvent,
  FlutterSendEvent,
  ElixirSendEvent,
  DotNetSendEvent,
  IdentifiedVsAnonymousIntro,
  HowToCaptureAnonymousEventsBackend,
  HowToCaptureAnonymousEventsIOS,
  HowToCaptureAnonymousEventsWeb,
  HowToCaptureAnonymousEventsAndroid,
  HowToCaptureAnonymousEventsFlutter,
  HowToCaptureIdentifiedEventsFrontend,
  HowToCaptureIdentifiedEventsBackend,
  HowToCaptureIdentifiedEventsAndroid,
  HowToCaptureIdentifiedEventsiOS,
  HowToCaptureIdentifiedEventsFlutter,
  React
};